/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.alertsModule')
.directive('bulbUnsupportedBrowserAlert', bulbUnsupportedBrowserAlert);

function bulbUnsupportedBrowserAlert() {
  return {
    restrict: 'E',
    scope: true,
    controller: 'UnsupportedBrowserAlertController as unsupportedBrowserAlertCtrl',
    templateUrl: 'ajs/alerts/unsupportedbrowseralert.html'
  };
}
